import type { datadogRum } from '@datadog/browser-rum';
import type { RealtimeRole } from '@doxyme/realtime';

export enum CustomDatadogContextKeys {
  Role = 'role',
}

export type CustomDatadogContext = {
  [CustomDatadogContextKeys.Role]: RealtimeRole;
};

export type DataDogUser = Parameters<typeof datadogRum.setUser>[0];
